import { Box, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledToolManagement = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .header-card {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-card-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .filters {
    display: flex;
    gap: 16px;
    align-items: center;
    margin-bottom: 16px;
  }

  .search-input {
    min-width: 30%;
  }

  .type-filter {
    min-width: 30%;
  }

  .body-card {
    margin-bottom: 64px;
  }

  .tool-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    object-fit: cover;
  }

  .no-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background-color: ${COLOR.charcoal[100]};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: ${COLOR.blueGray[64]};
  }

  .tool-code {
    font-size: 14px;
    color: ${COLOR.blueGray[80]};
  }
`;

export const StyledCreateToolModal = styled(Dialog)`
  .MuiDialog-paper {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    min-width: 1000px;
    max-width: 1200px;
    max-height: 95vh;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  .pd-0 {
    padding: 0 !important;
  }

  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    padding: 24px 32px 16px;
    // background: linear-gradient(
    //   135deg,
    //   ${COLOR.primary.base} 0%,
    //   ${COLOR.primary.dark} 100%
    // );
    // color: white;
    border-radius: 12px 12px 0 0;
    margin: 0;

    .MuiIconButton-root {
      // color: white;
      background-color: rgba(255, 255, 255, 0.1);
      transition: background-color 0.2s;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .dialog-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 32px;
    overflow-y: auto;
    flex: 1;
  }

  .section-title {
    font-size: 18px;
    font-weight: 700;
    color: ${COLOR.text.primary};
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid ${COLOR.primary.light};
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: ${COLOR.primary.base};
    }
  }

  .form-section {
    padding: 24px;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 12px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[8]} 100%
    );
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
      border-color: ${COLOR.primary.light};
    }
  }

  .file-upload-section {
    display: flex;
    gap: 32px;
    margin-top: 16px;
  }

  .file-upload-item {
    flex: 1;
    text-align: center;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 12px;
    background-color: ${COLOR.white[100]};
    transition: all 0.2s;

    &:hover {
      border-color: ${COLOR.primary.base};
      background-color: ${COLOR.primary[8]};
    }
  }

  .file-preview {
    width: 100px;
    height: 100px;
    border: 2px dashed ${COLOR.charcoal[48]};
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    cursor: pointer;
    transition: all 0.2s;
    background-color: ${COLOR.charcoal[8]};

    &:hover {
      border-color: ${COLOR.primary.base};
      background-color: ${COLOR.primary[8]};
      transform: translateY(-2px);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }
  }

  .language-tabs {
    margin-bottom: 24px;
    border-bottom: 1px solid ${COLOR.charcoal[32]};

    .MuiTab-root {
      font-weight: 600;
      text-transform: none;
      font-size: 16px;
      min-height: 48px;
      color: ${COLOR.text.primary};

      &.Mui-selected {
        color: ${COLOR.primary.base};
      }

      &:hover {
        color: ${COLOR.primary.dark};
      }
    }

    .MuiTabs-indicator {
      background-color: ${COLOR.primary.base};
      height: 3px;
      border-radius: 2px;
    }
  }

  .label-input {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    color: ${COLOR.text.primary};

    span {
      color: ${COLOR.error.base};
      margin-left: 4px;
    }
  }

  .error-text {
    color: ${COLOR.error.base};
    font-size: 12px;
    margin-top: 6px;
    font-weight: 500;
  }

  .MuiTextField-root {
    .MuiOutlinedInput-root {
      border-radius: 8px;
      transition: all 0.2s;

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${COLOR.primary.light};
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${COLOR.primary.base};
        border-width: 2px;
      }
    }
  }

  .MuiRadioGroup-root {
    .MuiFormControlLabel-root {
      margin-right: 24px;

      .MuiRadio-root {
        color: ${COLOR.charcoal[64]};

        &.Mui-checked {
          color: ${COLOR.primary.base};
        }
      }
    }
  }

  // .MuiButton-root {
  //   border-radius: 8px;
  //   font-weight: 600;
  //   text-transform: none;
  //   padding: 10px 24px;
  //   font-size: 14px;

  //   &.MuiButton-contained {
  //     background: linear-gradient(
  //       135deg,
  //       ${COLOR.primary.base} 0%,
  //       ${COLOR.primary.dark} 100%
  //     );
  //     box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  //     &:hover {
  //       box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  //       transform: translateY(-1px);
  //     }
  //   }
  // }

  @media (max-width: 1000px) {
    .MuiDialog-paper {
      min-width: 95vw;
      margin: 16px;
    }

    .dialog-content {
      padding: 24px;
    }

    .file-upload-section {
      flex-direction: column;
      gap: 20px;
    }
  }
`;

export const StyledDetailModal = styled(Dialog)`
  .MuiDialog-paper {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    min-width: 1000px;
    max-width: 1200px;
    max-height: 95vh;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    padding: 24px 32px 16px;
    // background: linear-gradient(
    //   135deg,
    //   ${COLOR.primary.base} 0%,
    //   ${COLOR.primary.dark} 100%
    // );
    // color: white;
    border-radius: 12px 12px 0 0;
    margin: 0;

    .MuiIconButton-root {
      // color: white;
      background-color: rgba(255, 255, 255, 0.1);
      transition: background-color 0.2s;

      &:hover {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .mode-toggle {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .dialog-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 32px;
    overflow-y: auto;
    flex: 1;
  }

  .section-title {
    font-size: 18px;
    font-weight: 700;
    color: ${COLOR.text.primary};
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid ${COLOR.primary.light};
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: ${COLOR.primary.base};
    }
  }

  .form-section {
    padding: 24px;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 12px;
    // background: linear-gradient(
    //   145deg,
    //   ${COLOR.white[100]} 0%,
    //   ${COLOR.charcoal[8]} 100%
    // );
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
      border-color: ${COLOR.primary.light};
    }
  }

  .file-upload-section {
    display: flex;
    gap: 32px;
    margin-top: 16px;
  }

  .file-upload-item {
    flex: 1;
    text-align: center;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 12px;
    background-color: ${COLOR.white[100]};
    transition: all 0.2s;

    &:hover {
      border-color: ${COLOR.primary.base};
      background-color: ${COLOR.primary[8]};
    }
  }

  .file-preview {
    width: 100px;
    height: 100px;
    border: 2px dashed ${COLOR.charcoal[48]};
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    cursor: pointer;
    transition: all 0.2s;
    background-color: ${COLOR.charcoal[8]};

    &:hover {
      border-color: ${COLOR.primary.base};
      background-color: ${COLOR.primary[8]};
      transform: translateY(-2px);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }
  }

  .language-tabs {
    margin-bottom: 24px;
    border-bottom: 1px solid ${COLOR.charcoal[32]};

    .MuiTab-root {
      font-weight: 600;
      text-transform: none;
      font-size: 16px;
      min-height: 48px;
      color: ${COLOR.text.primary};

      &.Mui-selected {
        color: ${COLOR.primary.base};
      }

      &:hover {
        color: ${COLOR.primary.dark};
      }
    }

    .MuiTabs-indicator {
      background-color: ${COLOR.primary.base};
      height: 3px;
      border-radius: 2px;
    }
  }

  .label-input {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    color: ${COLOR.text.primary};

    span {
      color: ${COLOR.error.base};
      margin-left: 4px;
    }
  }

  .error-text {
    color: ${COLOR.error.base};
    font-size: 12px;
    margin-top: 6px;
    font-weight: 500;
  }

  .readonly-field {
    // background: linear-gradient(
    //   145deg,
    //   ${COLOR.charcoal[8]} 0%,
    //   ${COLOR.charcoal[16]} 100%
    // ) !important;
    border-radius: 8px !important;

    .MuiOutlinedInput-notchedOutline {
      border-color: ${COLOR.charcoal[48]} !important;
      border-style: solid !important;
      border-width: 1px !important;
    }

    .MuiInputBase-input {
      color: ${COLOR.text.primary} !important;
      font-style: normal !important;
      font-weight: 500 !important;
      cursor: default !important;
    }

    .MuiInputBase-inputMultiline {
      color: ${COLOR.text.primary} !important;
      font-style: normal !important;
      font-weight: 500 !important;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${COLOR.primary.light} !important;
    }
  }

  .view-content {
    min-height: 40px;
    padding: 12px 16px;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 8px;
    // background: linear-gradient(
    //   145deg,
    //   ${COLOR.white[100]} 0%,
    //   ${COLOR.charcoal[4]} 100%
    // );
    display: flex;
    align-items: center;
    transition: all 0.2s;

    // &:hover {
    //   border-color: ${COLOR.primary.light};
    //   background: linear-gradient(
    //     145deg,
    //     ${COLOR.white[100]} 0%,
    //     ${COLOR.primary[4]} 100%
    //   );
    // }

    &.view-content-multiline {
      min-height: 80px;
      align-items: flex-start;
      padding-top: 12px;

      .view-text {
        line-height: 1.6;
        white-space: pre-wrap;
      }
    }
  }

  .view-text {
    color: ${COLOR.text.primary};
    font-weight: 500;
    font-size: 14px;
    word-break: break-word;

    &.code-text {
      background-color: ${COLOR.charcoal[8]};
      padding: 4px 8px;
      border-radius: 4px;
      color: ${COLOR.primary.dark};
    }
  }

  .MuiTextField-root {
    .MuiOutlinedInput-root {
      border-radius: 8px;
      transition: all 0.2s;

      &:hover .MuiOutlinedInput-notchedOutline {
        border-color: ${COLOR.primary.light};
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: ${COLOR.primary.base};
        border-width: 2px;
      }
    }
  }

  .MuiRadioGroup-root {
    .MuiFormControlLabel-root {
      margin-right: 24px;

      .MuiRadio-root {
        color: ${COLOR.charcoal[64]};

        &.Mui-checked {
          color: ${COLOR.primary.base};
        }
      }
    }
  }

  .MuiSwitch-root {
    .MuiSwitch-switchBase {
      &.Mui-checked {
        color: ${COLOR.primary.base};
      }
    }
  }

  @media (max-width: 1000px) {
    .MuiDialog-paper {
      min-width: 95vw;
      margin: 16px;
    }

    .dialog-content {
      padding: 24px;
    }

    .file-upload-section {
      flex-direction: column;
      gap: 20px;
    }
  }
`;

export const StyledMetadataModal = styled(Dialog)`
  .MuiDialog-paper {
    padding: 24px !important;
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 800px;
    max-height: 90vh;
    overflow-y: auto;
  }

  .color-section {
    border: 1px solid ${COLOR.charcoal[64]};
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
  }

  .color-group {
    margin-bottom: 24px;
  }

  .color-item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .color-preview {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid ${COLOR.charcoal[64]};
    cursor: pointer;
  }

  .color-input {
    flex: 1;
  }

  .json-editor {
    margin-top: 16px;
  }

  @media (max-width: 900px) {
    .MuiDialog-paper {
      min-width: 90vw;
      margin: 16px;
    }
  }
`;
